var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddTierBtnDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AddTier_Outline_24px",
    transform: "translate(0.06)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1188",
    "data-name": "Rectangle 1188",
    width: 24,
    height: 24,
    transform: "translate(-0.06)",
    fill: "#1450FF",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189",
    "data-name": "Rectangle 1189",
    width: 22,
    height: 22,
    transform: "translate(0.94 1)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    width: 22,
    height: 22,
    transform: "translate(0.94 1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986-2",
    width: 22,
    height: 22,
    transform: "translate(0.88 1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(11.31 17.86)",
    fill: "#1450FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M10.97,14.72,2.93,8.85a.834.834,0,0,1,0-1.43l8.04-5.87a1.771,1.771,0,0,1,1.95,0l8.04,5.87a.834.834,0,0,1,0,1.43l-8.04,5.87a1.771,1.771,0,0,1-1.95,0Z",
    fill: "none",
    stroke: "#1450FF",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M4.55,13.65,2.93,12.47a.834.834,0,0,1,0-1.43L4.6,9.82",
    fill: "none",
    stroke: "#1450FF",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x1: 5.51,
    y1: 4.01,
    transform: "translate(4.55 13.65)",
    fill: "none",
    stroke: "#1450FF",
    strokeLinecap: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M19.46,9.94l1.5,1.09a.834.834,0,0,1,0,1.43l-7.12,5.2",
    fill: "none",
    stroke: "#1450FF",
    strokeLinecap: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M19.48,13.54l1.45,1.06a.834.834,0,0,1,0,1.43L12.89,21.9a1.771,1.771,0,0,1-1.95,0L2.91,16.02a.834.834,0,0,1,0-1.43l1.3-.95",
    fill: "none",
    stroke: "#1450FF",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M12.13,3.63a4.5,4.5,0,1,0,4.5,4.5,4.494,4.494,0,0,0-4.5-4.5Zm1.73,4.85H12.48V9.86a.35.35,0,1,1-.7,0V8.48H10.4a.35.35,0,1,1,0-.7h1.38V6.4a.35.35,0,0,1,.7,0V7.78h1.38a.35.35,0,1,1,0,.7Z",
    fill: "#1450FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTierBtnDarkIcon);
export default __webpack_public_path__ + "static/media/add-tier-btn-dark-icon.06b431cc3887a140b7ecf33d6cb54b9a.svg";
export { ForwardRef as ReactComponent };